export const projectFile = "TailwindTranslator"
export const sourcePath = window.hasKrpano?`./frontEnd/plugin/${projectFile}/`:"./"